import { useState, useEffect } from "react";
import {
  Typography,
  Row,
  Col,
  Input,
  TimePicker,
  Select,
  DatePicker,
  Alert,
  notification,
} from "antd";
import { TiUserDelete } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import "moment/locale/az";
import dayjs from "dayjs";
import "dayjs/locale/az";

import {
  setAllEmployeesMails,
  setAllMeetingRoomNames,
} from "../../redux/actions/mainAction";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const format = "HH:mm";
const AddMeeting = () => {
  const [meetingName, setMeetingName] = useState("");
  const [meetingAuthor, setMeetingAuthor] = useState("");
  const [meetingAuthorFullName, setMeetingAuthorFullName] = useState("");
  const [meetingRoomName, setMeetingRoomName] = useState("");
  const [meetingStartDate, setMeetingStartDate] = useState("");
  const [meetingStartTime, setMeetingStartTime] = useState("");
  const [meetingStartTime2, setMeetingStartTime2] = useState("");
  const [meetingEndDate, setMeetingEndDate] = useState("");
  const [meetingEndTime, setMeetingEndTime] = useState("");
  const [meetingEndTime2, setMeetingEndTime2] = useState("");
  const [meetingAttenders, setMeetingAttenders] = useState([]);
  const [meetingGuest, setMeetingGuest] = useState("");
  const [meetingGuestList, setMeetingGuestList] = useState([]);
  const [meetingAbout, setMeetingAbout] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [showDateTimeAlert, setShowDateTimeAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);
  const dispatch = useDispatch();
  const currentDate = moment();
  const navigate = useNavigate();

  useEffect(() => {
    getEmployeesEmails();
    getMeetingRoomsNames();
  }, [GlobalResponse.triggeranyevent]);

  const getEmployeesEmails = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-employees-mails/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();

    dispatch(setAllEmployeesMails(result));
  };

  const getMeetingRoomsNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-meetingrooms-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();

    dispatch(setAllMeetingRoomNames(result));
  };

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Seçdiyiniz saatlar üçün seçdiyiniz otaq doludur!",
    });
  };

  const handleChangeAuthor = (value) => {
    setMeetingAuthor(value);
    const user = MainResponse.allEmployeesMails.find(
      (user) => user.value === value
    );
    const employeeFullName = user ? user.employeeFullName : "";
    setMeetingAuthorFullName(employeeFullName);
  };

  const handleChangeRoom = (value) => {
    setMeetingRoomName(value);
  };

  const pickStartDate = (date, dateString) => {
    setMeetingStartDate(dateString);
  };

  const pickStartTime = (time, timeString) => {
    setMeetingStartTime(time);
    setMeetingStartTime2(timeString);
  };

  const pickEndtDate = (date, dateString) => {
    setMeetingEndDate(dateString);
  };

  const pickEndtTime = (time, timeString) => {
    setMeetingEndTime(time);
    setMeetingEndTime2(timeString);
  };

  const handleChangeAttenders = (value) => {
    setMeetingAttenders(value);
  };

  const disabledDate = (current) => {
    return current && current < currentDate.startOf("day"); // Bu günün başlangıcından öncəki tarixləri disable edir
  };

  const addGuestHandler = () => {
    if (meetingGuest.length > 0) {
      const updatedGuestList = [...meetingGuestList];
      const newGuest = {
        _id: uuidv4(), // Benzersiz rastgele id oluşturulur
        employeeName: meetingGuest,
      };
      updatedGuestList.push(newGuest);
      setMeetingGuestList(updatedGuestList);
    }
    setMeetingGuest([]);
  };

  const removeGuestHandler = (id) => {
    const list = meetingGuestList.filter((guest) => guest._id !== id);
    setMeetingGuestList(list);
  };

  const saveMeeting = async () => {
    if (
      meetingName &&
      meetingAuthor &&
      meetingRoomName &&
      meetingStartDate &&
      meetingStartTime2 &&
      meetingEndDate &&
      meetingEndTime2 &&
      meetingAttenders &&
      meetingAbout
    ) {
      setShowAlert(false);
      if (
        meetingStartDate <= meetingEndDate &&
        meetingStartTime2 < meetingEndTime2
      ) {
        // Authoru attender-dən çıxar
        const updatedMeetingAttenders = meetingAttenders.filter(
          (attender) => attender !== meetingAuthor
        );
        setButtonDisable(true);

        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/add-meeting/`,
          {
            method: "post",
            body: JSON.stringify({
              meetingName,
              meetingAuthor,
              meetingAuthorFullName,
              meetingRoomName,
              meetingStartDate,
              meetingStartTime,
              meetingStartTime2,
              meetingEndDate,
              meetingEndTime,
              meetingEndTime2,
              meetingAttenders: updatedMeetingAttenders,
              meetingGuestList,
              meetingAbout,
            }),
            headers: {
              "Content-Type": "application/json",
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        result = await result.json();

        if (result.result === "Bu saatlarda görüş var!") {
          openNotificationWithIcon("error");
          setButtonDisable(false);
        } else {
          dispatch(setTriggerAnyEvent(Math.random()));
          setMeetingName("");
          setMeetingAuthor("");
          setMeetingRoomName("");
          setMeetingStartDate("");
          setMeetingStartTime("");
          setMeetingEndDate("");
          setMeetingEndTime("");
          setMeetingAttenders([]);
          setMeetingAbout("");
          setButtonDisable(false);
          navigate("/meetings");
        }
      } else {
        setShowDateTimeAlert(true);
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {contextHolder}

      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showDateTimeAlert && (
        <Alert
          onClose={() => setShowDateTimeAlert(false)}
          message="Diqqət!"
          description="Tarix və ya saatlarda bir səhv var!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Görüşün adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={meetingName}
            onChange={(e) => setMeetingName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">
            Görüşün rəhbəri
          </Typography.Text>

          <Select
            value={meetingAuthor}
            size="large"
            onChange={handleChangeAuthor}
            className="add-dropdown"
            options={MainResponse.allEmployeesMails}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            showSearch
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Otaq</Typography.Text>

          <Select
            value={meetingRoomName}
            size="large"
            onChange={handleChangeRoom}
            className="add-dropdown"
            options={MainResponse.allMeetingRoomNames}
          />
        </Col>

        <Col span={3}>
          <Typography.Text className="add-title">
            Başlama tarixi
          </Typography.Text>
          <DatePicker
            placeholder={false}
            disabledDate={disabledDate}
            defaultValue={
              meetingStartDate ? dayjs(meetingStartDate, "YYYY-MM-DD") : null
            }
            onChange={pickStartDate}
            className="add-datetime"
          />
        </Col>
        <Col span={3}>
          <Typography.Text className="add-title">Başlama saatı</Typography.Text>
          <TimePicker
            placeholder={false}
            value={meetingStartTime ? meetingStartTime : null}
            onChange={pickStartTime}
            className="add-datetime"
            format={format}
          />
        </Col>
      </Row>

      <Row className="add-row">
        <Col span={18}>
          <Typography.Text className="add-title">İştirakçılar</Typography.Text>

          <Select
            value={meetingAttenders}
            size="large"
            onChange={handleChangeAttenders}
            mode="multiple"
            className="add-dropdown-attenders"
            options={MainResponse.allEmployeesMails}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            showSearch
          />
        </Col>

        <Col span={3}>
          <Typography.Text className="add-title">Bitiş tarixi</Typography.Text>
          <DatePicker
            placeholder={false}
            disabledDate={disabledDate}
            defaultValue={
              meetingEndDate ? dayjs(meetingEndDate, "YYYY-MM-DD") : null
            }
            onChange={pickEndtDate}
            className="add-datetime"
          />
        </Col>

        <Col span={3}>
          <Typography.Text className="add-title">Bitiş saatı</Typography.Text>
          <TimePicker
            placeholder={false}
            value={meetingEndTime ? meetingEndTime : null}
            onChange={pickEndtTime}
            className="add-datetime"
            format={format}
          />
        </Col>
      </Row>

      <Row className="add-row">
        <Col span={20}>
          <Typography.Text className="add-title">Qonaqlar</Typography.Text>
          <Input
            placeholder="Adı və soyadı"
            className="add-input-guest"
            size="large"
            value={meetingGuest}
            onChange={(e) => setMeetingGuest(e.target.value)}
          />
        </Col>
        <Col span={4}>
          <button onClick={addGuestHandler} className="add-guest-button">
            Əlavə Et
          </button>
        </Col>
      </Row>
      {meetingGuestList.length > 0 && (
        <Row className="add-row">
          <Col span={24}>
            <div className="guest-list">
              {meetingGuestList.map((guest) => {
                return (
                  <div key={guest._id} className="guest-name-container">
                    <Typography.Text className="guest-name">
                      {guest.employeeName}
                    </Typography.Text>
                    <div
                      onClick={() => removeGuestHandler(guest._id)}
                      className="remove-guest"
                    >
                      <TiUserDelete color="red" />
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      )}

      <Row className="add-row">
        <Col span={24}>
          <Typography.Text className="add-title">
            Görüşün predmeti
          </Typography.Text>

          <Input.TextArea
            value={meetingAbout}
            onChange={(e) => setMeetingAbout(e.target.value)}
            autoSize={{
              minRows: 3,
              maxRows: 5,
            }}
            className="add-input-textarea"
          />
        </Col>
      </Row>

      <Row>
        <Col span={6}>
          <button
            disabled={buttonDisable}
            onClick={saveMeeting}
            className="add-button"
          >
            Əlavə Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default AddMeeting;
